import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { AlertModalComponent } from '@components/alert-modal/alert-modal.component';
import { CommonModule } from '@angular/common';
import { ProfileDetailComponent } from '@components/profile-detail/profile-detail.component';
import {
  Labels,
  Messages
} from '@modules/shared/components/vip-offer-list/constant';
import { ButtonComponent } from '@components/button/button.component';
import { Fields } from '@constants/constant';

@Component({
  selector: 'app-subscription-select-modal',
  templateUrl: './subscription-select-modal.component.html',
  styleUrls: ['./subscription-select-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    AlertModalComponent,
    ProfileDetailComponent,
    ButtonComponent
  ]
})
export class SubscriptionSelectModalComponent {
  @Input() contentType: string = 'offer';
  @Input() modalHeader: string;
  @Input() userProfile = null;
  @Input() availableSubList = [];
  @Input() headerType = '';
  @Input() modalOptions = {};

  @Output() confirmed = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  @ViewChild('subscriptionSelect') subscriptionSelectModal;

  labels = Labels;
  messages = Messages;
  Fields = Fields;
  openSubscriptionDetail(data) {
    this.confirmed.emit(data);
  }
  get fullName() {
    return `${this.userProfile?.first_name || ''} ${
      this.userProfile?.last_name || ''
    }`.trim();
  }
  openModal() {
    this.subscriptionSelectModal?.openModal();
  }
  closeModal() {
    this.subscriptionSelectModal?.closeModal();
  }

  handleCancel() {
    this.canceled.emit();
  }
}
